module.exports = __webpack_public_path__ + "img/img_t_2_deco.67fda917.png";